export const unlockAssessment = (
  assessmentData,
  dispatch,
  updateAssessmentAction,
  assessment
) => {
  const results = Object.keys(assessmentData.results);

  results.forEach((key: any) => {
    // const { correctAnswer, attemptCount } = assessmentData.results[key] as any;

    requestAnimationFrame(() => {
      dispatch(
        updateAssessmentAction({
          assessmentId: assessment.id,
          assessmentData: {
            ...assessmentData.data,
          },
          questionData: {
            [key]: {
              ...assessmentData.results[key],
              // answer: [],
              // correctAnswer,
              // isCorrect: undefined,
              // attemptCount,
              submitButtonLabel: 'Submit',
              // navigateToResults: false,
              isLocked: false,
            },
          },
        })
      );

      //
    });
  });
};
